export enum BalanceStatus {
    Outstanding = 'OUTSTANDING',
    Balanced = 'BALANCED',
    Overpaid = 'OVERPAID',
}
